// extracted by mini-css-extract-plugin
module.exports = {"main":"main--Spinner-Loading-components__1YkZ7","show":"show--Spinner-Loading-components__2MsSP","loader":"loader--Spinner-Loading-components__11uxk"};